var _defs, _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStylumiaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 37,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "60 10 255 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: #d61e89;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-8);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -12.24,
    y1: 79.01,
    x2: 376.93,
    y2: -25.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0046ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#004eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#0067ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#008fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00c5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "aqua"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -11.54,
    y1: 81.63,
    x2: 377.64,
    y2: -23.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -6.98,
    y1: 98.58,
    x2: 382.2,
    y2: -6.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -8.71,
    y1: 92.12,
    x2: 380.46,
    y2: -12.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -4.82,
    y1: 106.58,
    x2: 384.35,
    y2: 1.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1.58,
    y1: 118.62,
    x2: 387.64,
    y2: 13.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.78,
    y1: 127.4,
    x2: 389.95,
    y2: 22.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2.97,
    y1: 135.53,
    x2: 392.14,
    y2: 30.78,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m87.22,55.44c-1.36-.8-2.89-1.45-4.59-1.94-1.69-.49-3.43-.9-5.22-1.22-1.95-.34-3.65-.73-5.12-1.15-1.47-.42-2.6-.96-3.4-1.61-.8-.65-1.2-1.53-1.2-2.63s.41-1.93,1.24-2.56c.82-.63,1.86-1.08,3.11-1.34,1.25-.26,2.49-.4,3.73-.4,1.35,0,2.63.19,3.83.57,1.2.38,2.18.94,2.94,1.7.76.76,1.13,1.73,1.13,2.92v.48h7.38v-.62c0-2.4-.71-4.44-2.13-6.1-1.42-1.66-3.29-2.93-5.62-3.81-2.32-.88-4.85-1.32-7.57-1.32s-5.39.41-7.73,1.24c-2.34.82-4.19,2.04-5.56,3.64-1.37,1.6-2.06,3.55-2.06,5.84,0,1.76.39,3.27,1.19,4.52.79,1.25,1.85,2.29,3.19,3.13,1.34.84,2.85,1.51,4.53,2.01,1.68.5,3.43.92,5.24,1.24,3.32.55,5.8,1.18,7.44,1.89,1.64.71,2.46,1.9,2.46,3.57,0,1.03-.38,1.88-1.15,2.54-.77.66-1.8,1.16-3.09,1.48-1.29.32-2.72.48-4.28.48-2.66,0-4.76-.43-6.3-1.29s-2.32-2.12-2.32-3.8v-.69h-7.42v.93c0,1.81.41,3.4,1.22,4.77.81,1.37,1.95,2.52,3.4,3.45,1.45.93,3.14,1.63,5.07,2.11,1.92.48,3.97.72,6.15.72s4.12-.22,6.03-.67c1.91-.45,3.62-1.12,5.12-2.03,1.5-.9,2.68-2.04,3.55-3.42.87-1.37,1.31-3.01,1.31-4.91s-.41-3.38-1.22-4.64c-.81-1.26-1.9-2.29-3.26-3.09Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m109.09,24.94h-7.45v7.04c0,1.19-.03,2.13-.1,2.82-.07.69-.23,1.19-.5,1.49-.26.31-.68.5-1.24.58-.56.08-1.33.12-2.32.12h-4.6v6.18h8.76v21.29c0,2.04.3,3.69.89,4.95.6,1.26,1.39,2.23,2.39,2.9,1,.68,2.1,1.14,3.3,1.39,1.2.25,2.41.38,3.62.38.98,0,1.85-.07,2.61-.21.76-.14,1.34-.29,1.75-.45v-6.08c-.32.14-.79.26-1.41.38-.62.11-1.27.17-1.96.17-1.6,0-2.63-.53-3.07-1.58-.45-1.05-.67-2.5-.67-4.33v-18.82h10.71v-6.18h-10.71v-12.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m138.18,66.3l-8.89-29.31h-7.76l12.57,36.78-.93,2.75c-.41,1.24-.96,2.34-1.63,3.31-.68.97-1.5,1.73-2.47,2.28-.97.55-2.14.82-3.49.82-.76,0-1.48-.05-2.18-.14-.7-.09-1.2-.21-1.49-.34v6.08c.18.09.68.19,1.49.29.81.1,1.71.15,2.7.15,3.18,0,5.75-.56,7.69-1.68,1.95-1.12,3.5-2.65,4.67-4.59,1.17-1.94,2.15-4.13,2.95-6.58l13.09-39.15h-7.66l-8.66,29.31Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 156.62,
    y: 19.79,
    width: 7.35,
    height: 53.68
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m194.76,56.06c0,1.79-.4,3.57-1.2,5.34-.8,1.77-1.92,3.24-3.37,4.4-1.44,1.16-3.14,1.73-5.08,1.73-2.08,0-3.7-.45-4.86-1.36-1.16-.9-1.96-2.1-2.42-3.57-.46-1.48-.69-3.1-.69-4.86v-20.74h-7.49v22.63c0,1.63.21,3.29.62,5,.41,1.71,1.12,3.27,2.13,4.71,1.01,1.43,2.37,2.59,4.09,3.47,1.72.88,3.87,1.32,6.46,1.32,2.31,0,4.4-.45,6.27-1.34,1.87-.89,3.45-2.11,4.76-3.66.28-.33.54-.68.79-1.03v5.37h7.45v-36.48h-7.45v19.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m254.96,38.06c-1.76-1.1-4.02-1.65-6.77-1.65s-5.25.69-7.3,2.08c-1.81,1.22-3.25,2.81-4.33,4.76-.03-.08-.05-.17-.08-.26-.78-2.03-2.03-3.63-3.76-4.81-1.73-1.18-4.02-1.77-6.89-1.77s-5.26.7-7.33,2.11c-1.3.88-2.42,1.96-3.35,3.21v-4.74h-7.45v36.48h7.45v-19.78c0-1.26.15-2.51.45-3.76.3-1.25.78-2.38,1.44-3.4.66-1.02,1.53-1.84,2.61-2.46,1.08-.62,2.39-.93,3.95-.93s2.78.27,3.67.82c.89.55,1.55,1.27,1.97,2.15.42.88.7,1.83.82,2.83.13,1.01.19,1.96.19,2.85v21.67h7.38v-20.2c0-1.17.14-2.35.41-3.54.27-1.19.73-2.28,1.37-3.28.64-1,1.49-1.8,2.56-2.4,1.06-.61,2.39-.91,3.97-.91s2.86.27,3.76.81c.9.54,1.57,1.23,2.01,2.08.43.85.71,1.77.82,2.76.11,1,.17,1.96.17,2.9v21.78h7.42v-24.08c0-2.56-.42-4.82-1.27-6.77-.85-1.95-2.15-3.47-3.92-4.57Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m268.02,36.95l-2.5,36.53h7.35l-2.5-36.53c-.14-1.41-2.2-1.41-2.35,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m312.71,72.51c-.29-.46-.53-1.04-.74-1.75-.18-.62-.31-1.32-.38-2.11-.07-.79-.1-1.61-.1-2.46v-17.41c0-2.72-.74-5-2.23-6.83-1.49-1.83-3.49-3.21-5.99-4.14-2.51-.93-5.28-1.39-8.33-1.39-3.32,0-6.26.51-8.83,1.53-2.56,1.02-4.57,2.5-6.03,4.45-1.45,1.95-2.18,4.32-2.18,7.11h7.32c0-2.36.84-4.08,2.52-5.17,1.68-1.09,4.07-1.63,7.16-1.63,2.93,0,5.19.48,6.77,1.44,1.58.96,2.37,2.37,2.37,4.22v.07c0,.94-.89,1.61-2.66,2.03-1.77.41-4.83.84-9.15,1.27-2.91.27-5.5.85-7.78,1.73-2.28.88-4.06,2.12-5.36,3.73-1.29,1.6-1.94,3.63-1.94,6.08,0,2.29.57,4.25,1.72,5.87,1.14,1.63,2.75,2.87,4.83,3.74,2.07.87,4.48,1.31,7.23,1.31,2.36,0,4.51-.27,6.44-.82,1.93-.55,3.59-1.32,4.98-2.3.75-.53,1.39-1.12,1.94-1.76.1.64.24,1.22.42,1.72.21.6.44,1.12.7,1.56.26.45.46.74.6.88h7.42c-.18-.18-.42-.5-.7-.96Zm-14.43-5.51c-1.75.68-3.69,1.01-5.82,1.01-2.66,0-4.63-.44-5.92-1.32-1.29-.88-1.94-2.2-1.94-3.97s.78-3.14,2.34-3.93c1.56-.79,3.88-1.32,6.97-1.6,2.24-.23,4.42-.52,6.54-.88,1.34-.23,2.54-.5,3.62-.81v3.16c0,2.11-.53,3.85-1.58,5.24-1.05,1.39-2.46,2.42-4.21,3.09Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m274.51,24.13c-2.73-1.01-3.84-4.07-4.85-6.8-.16-.44-.79-.44-.95,0-1.01,2.73-2.12,5.79-4.85,6.8-.44.16-.44.79,0,.95,2.73,1.01,3.84,4.07,4.85,6.8.16.44.79.44.95,0,1.01-2.73,2.12-5.79,4.85-6.8.44-.16.44-.79,0-.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStylumiaLogo);
export default __webpack_public_path__ + "static/media/stylumia_logo.4ab598539d16d676fa7a4f883ab775db.svg";
export { ForwardRef as ReactComponent };